import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { JourneyProvider } from "./context/JourneyContext";

// Pages
import WelcomeScreen from "./pages/WelcomeScreen";
import UserTypeSelection from "./pages/UserTypeSelection";
import RecommendationScreen from "./pages/RecommendationScreen";
import Browse from "./pages/Browse";
import LSPlus from "./pages/LSPlus";
import Merch from "./pages/Merch";

// Portal pages
import YourNeed from "./pages/portal/YourNeed";
import Proof from "./pages/portal/Proof";
import Options from "./pages/portal/Options";
import NextStep from "./pages/portal/NextStep";
import ContinueJourney from "./pages/portal/ContinueJourney";

function App() {
  return (
    <JourneyProvider>
      <div className="App min-h-screen bg-background">
        <BrowserRouter>
          <Routes>
            {/* Main entry flow */}
            <Route path="/" element={<WelcomeScreen />} />
            <Route path="/choose-path" element={<UserTypeSelection />} />
            <Route path="/recommendation" element={<RecommendationScreen />} />
            
            {/* Portal flow */}
            <Route path="/portal/your-need" element={<YourNeed />} />
            <Route path="/portal/proof" element={<Proof />} />
            <Route path="/portal/options" element={<Options />} />
            <Route path="/portal/next-step" element={<NextStep />} />
            <Route path="/portal/continue-journey" element={<ContinueJourney />} />
            
            {/* Browse / LS+ / Merch */}
            <Route path="/browse" element={<Browse />} />
            <Route path="/ls-plus" element={<LSPlus />} />
            <Route path="/merch" element={<Merch />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </JourneyProvider>
  );
}

export default App;
